import {
  COMMUNICATION_EMAIL, EMAILS_PAGINATE, GET_COMMUNICATION_EMAILS, NEW_COMMUNICATION_EMAIL,
  EDIT_COMMUNICATION_EMAIL_STATUS, NOTIFICATIONS_INCLUDE
} from '@store/types'
import axios from 'axios'
import shortly from 'vuex-shortly'
import moment from 'moment'
import { toDeepFormData } from '@/helpers/cast'

const state = {
  communication_email: [],
  emails_paginate: {}
}

const getters = {
  [COMMUNICATION_EMAIL]: (state) => state.communication_email,
  [EMAILS_PAGINATE]: 'emails_paginate'
}

const mutations = {
  [COMMUNICATION_EMAIL]: (state, payload) => {
    state.communication_email = payload
  },
  [EMAILS_PAGINATE]: 'emails_paginate'
}

const actions = {
  [GET_COMMUNICATION_EMAILS]: async ({ commit }, filters) => {
    const filtersKeys = Object.keys(filters)
    let stringFilters = ''
    filtersKeys.forEach(key => {
      if (filters[`${key}`] !== null && filters[key] !== undefined && filters[key] !== '') {
        stringFilters += `${key}=${filters[key]}&`
      }
    })
    const response = await axios.get(`/communication/email?${stringFilters}`)
    const paginate = { ...response.data, per_page: filters.limit }
    delete paginate.data
    commit(EMAILS_PAGINATE, paginate)
    commit(COMMUNICATION_EMAIL, response.data.data)
  },

  [NEW_COMMUNICATION_EMAIL]: async ({ dispatch }, payload) => {
    try {
      let data = JSON.parse(JSON.stringify(payload))
      if (data.communicate_all_companies) data.communicate_all_companies = +data.communicate_all_companies
      else delete data.communicate_all_companies
      if (data.companies) {
        data.companies = payload.companies.map(company => {
          return company.id
        })
      }
      data.start_date = moment((`${payload.start_date} ${payload.sending_hour}`), 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
      data.images = payload.images.map(image => {
        delete image.preview
        return image
      })
      data = toDeepFormData(data)
      const response = await axios.post('/communication/email', data)
      dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Email disparado com sucesso!' })
      return response.data
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, { type: 'error', message: 'Houve um problema ao disparar o email' })
      return { success: false }
    }
  },

  [EDIT_COMMUNICATION_EMAIL_STATUS]: async ({ state, commit, dispatch }, emailId) => {
    try {
      await axios.put(`/communication/email/${emailId}/cancel`)
      dispatch(NOTIFICATIONS_INCLUDE, { type: 'success', message: 'Envio cancelado com sucesso!' })
      let updatedEmails = JSON.parse(JSON.stringify(state.communication_email))
      updatedEmails = updatedEmails.map(email => {
        if (email.id === emailId) email.status = 0
        return email
      })
      commit(COMMUNICATION_EMAIL, updatedEmails)
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, { type: 'error', message: 'Houve um problema ao cancelar o envio' })
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/communication.js